// extracted by mini-css-extract-plugin
export default {"fullWidth":"ep-z","image":"fp-z","lazyLoadPicture":"gp-z","lazyLoadSpinner":"hp-z","lazyLoadSpin":"ip-z","lazyLoadImage":"jp-z","hasStyledAspectRatio":"kp-z"};